<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم (تختفي عند الطباعة) -->
    <div class="card shadow-sm mb-4 border-top-dark no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 fw-bold text-dark">
          <i class="fas fa-tags ms-2"></i> طباعة ملصقات المدارس (Stickers)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-6">
            <label class="form-label fw-bold">اختر المدرسة</label>
            <select v-model="selectedSchoolId" @change="fetchSchoolData" class="form-select form-select-lg">
              <option value="">-- اختر المدرسة --</option>
              <option v-for="s in schoolsList" :key="s.id" :value="s.id">{{ s.name }}</option>
            </select>
          </div>
          
          <div class="col-md-3">
             <!-- خيار لطباعة نسختين لنفس المدرسة أو مدرستين مختلفتين (سنعتمد نسختين لنفس المدرسة) -->
             <div class="form-check mt-2">
               <input class="form-check-input" type="checkbox" checked disabled id="copyCheck">
               <label class="form-check-label" for="copyCheck">
                 طباعة نسختين في الورقة (أعلى وأسفل)
               </label>
             </div>
          </div>

          <div class="col-md-3">
             <button @click="printPage" class="btn btn-dark w-100 btn-lg" :disabled="!schoolData">
               <i class="fas fa-print ms-2"></i> طباعة الملصق
             </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة (A4 مقسمة لجزئين) -->
   <div id="printMe" v-if="schoolData">
      
      <!-- تكرار الكود مرتين (مرة للنصف الأعلى ومرة للنصف الأسفل) -->
      <div class="sticker-half" v-for="n in 2" :key="n">
        
        <div class="sticker-box">
            <!-- أ. ترويسة -->
            <div class="sticker-header">
                <div class="row align-items-center">
                    <div class="col-3 text-center">
                        <img src="/img/logo/edu.png" alt="logo" style="height: 60px; grayscale: 100%;">
                    </div>
                    <div class="col-6 text-center">
                        <h4 class="mb-1 fw-bold">محافظة شمال سيناء</h4>
                        <h5 class="mb-0">لجنة النظام والمراقبة</h5>
                    </div>
                    <div class="col-3 text-center">
                        <div class="school-num-badge">
                            <small>رقم المدرسة</small>
                            <strong>{{ schoolData.school_number }}</strong>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ب. جسم الملصق (اسم المدرسة) -->
            <div class="sticker-body">
                <h1 class="school-name">{{ schoolData.name }}</h1>
                <div class="sector-badge">قطاع: {{ schoolData.sector }}</div>
            </div>

            <!-- ج. جدول الإحصاء -->
            <div class="sticker-footer">
                <table class="stats-table">
                    <thead>
                        <tr>
                            <th>بنين</th>
                            <th>بنات</th>
                            <th class="bg-dark text-white">الإجمالي</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ schoolData.stats.boys }}</td>
                            <td>{{ schoolData.stats.girls }}</td>
                            <td class="fw-bold fs-3">{{ schoolData.stats.total }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- خط القص (يظهر فقط بعد النسخة الأولى) -->
        <!-- <div v-if="n === 1" class="cut-line-dashed">
             <i class="fas fa-cut"></i> قص هنا
        </div> -->
      </div>
      </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "SchoolStickerPrint",
  data() {
    return {
    //   schoolsList: [],
    //   selectedSchoolId: '',
      schoolData: null
    };
  },
  mounted() {
    // this.fetchSchoolsList();
    this.fetchSchoolData();
  },
  methods: {
    // async fetchSchoolsList() {
    //    try {
    //      const res = await api.get('/admin/get-schools-list'); // قائمة مختصرة
    //      this.schoolsList = res.data;
    //    } catch(e) { console.error(e); }
    // },

    async fetchSchoolData() {
    //   if(!this.selectedSchoolId) return;
      
      try {
        // استدعاء API يجلب تفاصيل المدرسة وإحصائياتها
        // const res = await api.get(`/admin/school-sticker/${this.selectedSchoolId}`);
        // this.schoolData = res.data;
        
        /* بيانات للمحاكاة في حالة عدم وجود API جاهز */
    
        this.schoolData = {
            name: "مدرسة الشهيد أحمد عبد العزيز الإعدادية بنين",
            school_number: "105",
            sector: "العريش",
            stats: {
                boys: 120,
                girls: 0,
                total: 120
            }
        };
        
      } catch (e) {
        alert("خطأ في جلب البيانات");
      }
    },

    printPage() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;700;900&display=swap');

.border-top-dark { border-top: 4px solid #000; }

/* === تنسيقات الطباعة === */
#printMe {
    font-family: 'Cairo', sans-serif;
    width: 210mm;
    min-height: 296mm; /* ارتفاع A4 */
    background: white;
    margin: 0 auto;
    overflow: hidden;
}

/* النصف الواحد من الصفحة */
.sticker-half {
    width: 100%;
    height: 148mm; /* نصف ارتفاع A4 بالضبط (297/2) */
    padding: 5mm; /* هامش خارجي للحفاظ على حدود الطابعة */
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* الصندوق الأسود المحيط */
.sticker-box {
    border: 4px solid #000;
    border-radius: 12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 15px;
    justify-content: space-between;
}

/* الترويسة */
.sticker-header {
    border-bottom: 2px solid #000;
    padding-bottom: 10px;
}

.school-num-badge {
    border: 2px solid #000;
    padding: 5px;
    border-radius: 8px;
    background: #f0f0f0;
    display: inline-block;
    min-width: 80px;
}
.school-num-badge small { display: block; line-height: 1; }
.school-num-badge strong { font-size: 22px; font-weight: 900; }

/* الاسم */
.sticker-body {
    text-align: center;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.school-name {
    font-size: 40px; /* خط ضخم */
    font-weight: 900;
    line-height: 1.2;
    margin: 10px 0;
}
.sector-badge {
    font-size: 22px;
    font-weight: bold;
    background: #000;
    color: #fff;
    padding: 5px 30px;
    border-radius: 50px;
}

/* الجدول */
.stats-table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
    margin-top: 10px;
}
.stats-table th, .stats-table td {
    border: 2px solid #000;
    padding: 5px;
    font-size: 18px;
    font-weight: bold;
}
.stats-table th { background-color: #e9ecef; }

/* خط القص */
.cut-line-dashed {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-bottom: 2px dashed #999;
    text-align: center;
    color: #999;
    font-size: 12px;
    line-height: 0; /* لضبط النص على الخط */
}
.cut-line-dashed i { background: white; padding: 0 5px; }

/* إعدادات الميديا للطابعة */
@media print {
  @page {
    size: A4 portrait; /* طولي */
    margin: 0;
  }
  
  body { margin: 0; }
  .no-print { display: none !important; }
  
  #printMe { width: 100%; height: 100%; }
  
  .sticker-half {
      height: 148mm; /* تثبيت الارتفاع بدقة */
      page-break-inside: avoid;
  }
  
  /* إجبار الألوان والخلفيات */
  .bg-dark { background-color: #000 !important; color: #fff !important; -webkit-print-color-adjust: exact; }
  .sector-badge { background-color: #000 !important; color: #fff !important; -webkit-print-color-adjust: exact; }
  .school-num-badge { background-color: #f0f0f0 !important; -webkit-print-color-adjust: exact; }
}
</style>